import styles from './MainMethods.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface MainMethodsItem {
  src: string
  title: string
  description: string | JSX.Element
  inpocketUrl: string
  inpocketTitle: string
  noteUrl: string
  noteTitle: string
}

interface MainMethodsToolsProps {
  items: MainMethodsItem[]
}

const MainMethodsTools: React.FC<MainMethodsToolsProps> = ({ items }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.methods} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>主たる手法</h2>
      <p className={styles.sectionRead}>UX/UI設計で使用している主な手法をご紹介します。</p>
      <div className={styles.wrapper}>
        {items.map((item, index) => (
          <div key={index} className={styles.content}>
            <figure className={styles.content__img}>
              <img src={item.src} alt={item.title} />
            </figure>
            <h3 className={styles.content__title}>{item.title}</h3>
            <p className={styles.content__text}>{item.description}</p>
            {(item.inpocketTitle || item.inpocketUrl || item.noteTitle || item.noteUrl) && (
              <dl className={styles.related}>
                <dt className={styles.related__title}>関連記事</dt>
                <dd className={styles.related__cts}>
                  {item.inpocketTitle &&
                    item.inpocketUrl && ( // inpocketの条件付きレンダリング
                      <p className={styles.related__cts__text}>
                        <a className={styles.related__cts__text__inpocket} href={item.inpocketUrl}>
                          {item.inpocketTitle}
                        </a>
                      </p>
                    )}
                  {item.noteTitle &&
                    item.noteUrl && ( // noteの条件付きレンダリング
                      <p className={styles.related__cts__text}>
                        <a className={styles.related__cts__text__note} href={item.noteUrl} target="_blank">
                          {item.noteTitle}
                        </a>
                      </p>
                    )}
                </dd>
              </dl>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}

export default MainMethodsTools
